import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('chemicalMixSelectPanelField');

    return {
        NO_MIXES_FOUND: t('noMixesFound'),
        SEARCH: t('search')
    };
};

export default useTranslation;
